export const ROUTE = {
  HOME: {
    LINK: '/',
  },
  DASHBOARD: {
    LINK: '/dashboard',
    NAME: 'dashboard',
  },
  CONVERSATION: {
    LINK: '/conversation',
    NAME: 'conversation',
  },
  CONVERSATION_MANAGE: {
    LINK: '/conversation/[user_id]',
    NAME: 'conversation-user_id',
  },
  CONVERSATION_MANAGE_DETAIL: {
    LINK: '/conversation/[user_id]/[chat_id]',
    NAME: 'conversation-user_id-chat_id',
  },
  PRESET: {
    LINK: '/preset',
    NAME: 'preset',
  },
  PRESET_MANAGE: {
    LINK: '/preset/[id]',
    NAME: 'preset-id',
  },
  QUOTA: {
    LINK: '/quota',
    NAME: 'quota',
  },
  QUOTA_MANAGE: {
    LINK: '/quota/[quota_id]',
    NAME: 'quota-quota_id',
  },
  APPLICATION: {
    LINK: '/access-management/applications',
    NAME: 'access-management-applications',
  },
  APPLICATION_MANAGE: {
    LINK: '/access-management/applications/[application_id]',
    NAME: 'access-management-applications-application_id',
  },
  SCOPE: {
    LINK: '/access-management/scopes',
    NAME: 'access-management-scopes',
  },
  SCOPE_MANAGE: {
    LINK: '/access-management/scopes/[scope_id]',
    NAME: 'access-management-scopes-scope_id',
  },
  USER: {
    LINK: '/access-management/users',
    NAME: 'access-management-users',
  },
  USER_MANAGE: {
    LINK: '/access-management/users/[user_id]',
    NAME: 'access-management-users-user_id',
  },
  ROLES: {
    LINK: '/access-management/roles',
    NAME: 'access-management-roles',
  },
  ROLES_MANAGE: {
    LINK: '/access-management/roles/[role_id]',
    NAME: 'access-management-roles-role_id',
  },
  TOKEN_USAGE_REPORT: {
    LINK: '/report/token-usage',
    NAME: 'report-token-usage',
  },
  TOKEN_USAGE_REPORT_DETAIL: {
    LINK: '/report/token-usage/[user_id]',
    NAME: 'report-token-usage-user_id',
  },
  TOKEN_USAGE_REPORT_DETAIL_HISTORY_DETAIL: {
    LINK: '/report/token-usage/[user_id]/[id]',
    NAME: 'report-token-usage-user_id-id',
  },
  // APPLICATION: {
  //   LINK: '/access-management/application',
  // },
  // APPLICATION_MANAGE: {
  //   LINK: '/access-management/application/[id]',
  // },
  // SCOPE: {
  //   LINK: '/access-management/scope',
  // },
  // SCOPE_MANAGE: {
  //   LINK: '/access-management/scope/[scope_id]',
  // },
  // USER: {
  //   LINK: '/access-management/user',
  // },
  // USER_MANAGE: {
  //   LINK: '/access-management/user/[user_id]',
  // },
  LOGIN: {
    LINK: '/login',
    NAME: 'login',
  },
  WORKFLOW: {
    LINK: '/workflow',
    NAME: 'workflow',
  },
  WORKFLOW_MANAGE: {
    LINK: '/workflow/[id]',
    NAME: 'workflow-id',
  },
  KNOWLEDGE: {
    LINK: '/knowledge',
    NAME: 'knowledge',
  },
  KNOWLEDGE_MANAGE: {
    LINK: '/knowledge/[id]',
    NAME: 'knowledge-id',
  },
  PROMPT: {
    LINK: '/prompt-library',
    NAME: 'prompt-library',
  },
  AI_MANAGEMENT: {
    LINK: '/ai-management',
    NAME: 'ai-management',
  },
  AI_MANAGEMENT_MANAGE: {
    LINK: '/ai-management/[id]',
    NAME: 'ai-management-id',
  },
  KNOWLEDGE_BASE: {
    LINK: '/knowledge-base',
    NAME: 'knowledge-base',
  },
  KNOWLEDGE_BASE_MANAGE: {
    LINK: '/knowledge-base/[id]',
    NAME: 'knowledge-base-id',
  },
  SEMANTIC_CACHE: {
    LINK: '/semantic-cache',
    NAME: 'semantic-cache',
  },
  SEMANTIC_CACHE_MANAGE: {
    LINK: '/semantic-cache/[id]',
    NAME: 'semantic-cache-id',
  },
  SEMANTIC_CACHE_PLAYGROUND: {
    LINK: '/semantic-cache/playground',
    NAME: 'semantic-cache-playground',
  },
  AI_ACCURACY_REPORT: {
    LINK: '/ai-accuracy-report',
    NAME: 'ai-accuracy-report',
  },
  CONVERSATION_HISTORY: {
    LINK: '/conversation-history',
    NAME: 'conversation-history',
  },
  HISTORY_LOG: {
    LINK: '/history-log',
    NAME: 'history-log',
  },
};
